webpackJsonp([35783957827783],{

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 279);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1);
	
	/***/ }),
	
	/***/ 1:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(3);
	
	/***/ }),
	
	/***/ 14:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Link;
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _general = __webpack_require__(27);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _state = __webpack_require__(28);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _type = __webpack_require__(29);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var cx = _bind2.default.bind(_extends({}, _general2.default, _state2.default, _type2.default));
	
	/**
	 * There are a variety of different link styles available to be used across the
	 * product, marketing site and the blog. The optional `type` prop defines the
	 * link style and the optional `hasUnderline` style adds a underline to each link.
	 */
	function Link(_ref) {
	  var _cx;
	
	  var alt = _ref.alt,
	      block = _ref.block,
	      children = _ref.children,
	      download = _ref.download,
	      hasUnderline = _ref.hasUnderline,
	      id = _ref.id,
	      isActive = _ref.isActive,
	      isDisabled = _ref.isDisabled,
	      onClick = _ref.onClick,
	      tabIndex = _ref.tabIndex,
	      target = _ref.target,
	      title = _ref.title,
	      type = _ref.type,
	      url = _ref.url,
	      dataBypass = _ref['data-bypass'];
	
	  var linkClasses = cx('link', (_cx = {}, _defineProperty(_cx, type + '-isActive', isActive && !isDisabled), _defineProperty(_cx, type + '-hasUnderline', hasUnderline), _defineProperty(_cx, type + '-isDisabled', isDisabled), _defineProperty(_cx, type, !isActive && !isDisabled), _defineProperty(_cx, 'display-block', block), _defineProperty(_cx, 'display-inlineBlock', !block), _defineProperty(_cx, 'isDisabled', isDisabled), _cx));
	
	  var linkProps = {
	    alt: alt,
	    className: linkClasses,
	    id: id,
	    onClick: onClick,
	    title: title,
	    tabIndex: tabIndex
	  };
	  if (dataBypass) {
	    linkProps['data-bypass'] = true;
	  }
	
	  if (url) {
	    return _react2.default.createElement(
	      'a',
	      _extends({}, linkProps, { download: download, target: target, href: url }),
	      children
	    );
	  }
	  return _react2.default.createElement(
	    'span',
	    linkProps,
	    children
	  );
	}
	
	Link.propTypes = {
	  alt: _propTypes2.default.string,
	  block: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  download: _propTypes2.default.bool,
	  hasUnderline: _propTypes2.default.bool,
	  id: _propTypes2.default.string,
	  isActive: _propTypes2.default.bool,
	  isDisabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.number,
	  target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
	  title: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(Object.keys(_type2.default)).isRequired,
	  url: _propTypes2.default.string,
	  'data-bypass': _propTypes2.default.bool
	};
	
	Link.defaultProps = {
	  block: false,
	  download: false,
	  hasUnderline: false,
	  isActive: false,
	  type: 'light'
	};
	
	/***/ }),
	
	/***/ 2:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(19);
	
	/***/ }),
	
	/***/ 27:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"link":"general__link___2uaDd cursor-pointer textDecoration-none transitionDuration-m transitionProperty-all transitionTimingFunction-linear","isDisabled":"general__isDisabled___13hDh pointerEvents-none userSelect-none"};
	
	/***/ }),
	
	/***/ 279:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tabs = __webpack_require__(280);
	
	Object.defineProperty(exports, 'Tabs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tabs).default;
	  }
	});
	
	var _TabLink = __webpack_require__(76);
	
	Object.defineProperty(exports, 'TabLink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TabLink).default;
	  }
	});
	
	var _TabPane = __webpack_require__(78);
	
	Object.defineProperty(exports, 'TabPane', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TabPane).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/***/ }),
	
	/***/ 28:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"light-isActive":"state__light-isActive___2naAu c-marvel c-blue--d--hover","light-isDisabled":"state__light-isDisabled___3uVvv c-smoke--xd","light-hasUnderline":"state__light-hasUnderline___2COHc underline underline--smoke--xd","lightBlue-isActive":"state__lightBlue-isActive___hxX3- c-marvel c-blue--d--hover","lightBlue-isDisabled":"state__lightBlue-isDisabled___2cpBs c-smoke--xd","lightBlue-hasUnderline":"state__lightBlue-hasUnderline___UDm8k underline underline--smoke--xd","lightReversed-isActive":"state__lightReversed-isActive___1sL3h c-white c-white--hover","lightReversed-isDisabled":"state__lightReversed-isDisabled___1Bj6n c-smoke--xd","lightReversed-hasUnderline":"state__lightReversed-hasUnderline___2ayte underline underline--silver","dark-isActive":"state__dark-isActive___1sgHj c-marvel c-blue--d--hover","dark-isDisabled":"state__dark-isDisabled___18Q5n c-silver","dark-hasUnderline":"state__dark-hasUnderline___1_LJo underline underline--smoke--xd","negative-isActive":"state__negative-isActive___WKEbm c-slate c-negative--hover","negative-isDisabled":"state__negative-isDisabled___2sRV4 c-silver","negative-hasUnderline":"state__negative-hasUnderline___1BO_G underline underline--smoke--xd","blue-isActive":"state__blue-isActive___170NY c-blue c-blue--d--hover","blue-isDisabled":"state__blue-isDisabled___gG9pF c-blue opacity-70","blue-hasUnderline":"state__blue-hasUnderline___1m5Cl underline underline--marvel","green-isActive":"state__green-isActive___Vz44X c-green c-green--d--hover","green-isDisabled":"state__green-isDisabled___2AKVK c-green opacity-70","green-hasUnderline":"state__green-hasUnderline___1vQxK underline underline--green","orange-isActive":"state__orange-isActive___2UKHh c-orange c-orange--d--hover","orange-isDisabled":"state__orange-isDisabled___1AwH0 c-orange opacity-70","orange-hasUnderline":"state__orange-hasUnderline___3zfv4 underline underline--orange","teal-isActive":"state__teal-isActive___2pwQe c-teal c-teal--d--hover","teal-isDisabled":"state__teal-isDisabled___2G4QF c-teal opacity-70","teal-hasUnderline":"state__teal-hasUnderline___P7nQi underline underline--teal","purple-isActive":"state__purple-isActive___mhiwL c-purple c-purple--d--hover","purple-isDisabled":"state__purple-isDisabled___3gwaz c-purple opacity-70","purple-hasUnderline":"state__purple-hasUnderline___2oQ_O underline underline--purple","red-isActive":"state__red-isActive___3uyen c-red c-red--d--hover","red-isDisabled":"state__red-isDisabled___11j6j c-red opacity-70","red-hasUnderline":"state__red-hasUnderline___p1zDE underline underline--red","opaque-isActive":"state__opaque-isActive___2hIwr c-white opacity-100 c-white--hover","opaque-isDisabled":"state__opaque-isDisabled___HZWHM c-white opacity-40","opaque-hasUnderline":"state__opaque-hasUnderline___11xok underline underline--white--transparent","opaqueReversed-isActive":"state__opaqueReversed-isActive___WHruu c-marvel opacity-100 opacity-60--hover","opaqueReversed-isDisabled":"state__opaqueReversed-isDisabled___15RMw c-white opacity-60","opaqueReversed-hasUnderline":"state__opaqueReversed-hasUnderline___17gvm underline underline--white--transparent","snowBg-isActive":"state__snowBg-isActive___ZDNsF c-slate bg-snow--hover bg-snow--d--hover","snowBg-isDisabled":"state__snowBg-isDisabled___2gjHW c-silver","snowBg-hasUnderline":"state__snowBg-hasUnderline___25VIF underline underline--smoke--xd"};
	
	/***/ }),
	
	/***/ 280:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(2);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TabLink = __webpack_require__(76);
	
	var _TabLink2 = _interopRequireDefault(_TabLink);
	
	var _TabPane = __webpack_require__(78);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _general = __webpack_require__(282);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _size = __webpack_require__(77);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _sidebarSize = __webpack_require__(283);
	
	var _sidebarSize2 = _interopRequireDefault(_sidebarSize);
	
	var _utils = __webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var alignClasses = {
	  left: 'textAlign-left',
	  center: 'textAlign-center',
	  right: 'textAlign-right'
	};
	
	var Tabs = function (_Component) {
	  _inherits(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedTab: null
	    }, _this.handleSelect = function (tab) {
	      _this.setState({
	        selectedTab: tab
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tabs, [{
	    key: 'render',
	    value: function render() {
	      var isVertical = this.props.isVertical;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)({
	            'display-flex': isVertical
	          })
	        },
	        this.renderTabLinks(),
	        this.renderActivePane()
	      );
	    }
	  }, {
	    key: 'renderTabLinks',
	    value: function renderTabLinks() {
	      var _cx;
	
	      var _props = this.props,
	          align = _props.align,
	          children = _props.children,
	          isVertical = _props.isVertical,
	          justified = _props.justified,
	          isDisabled = _props.isDisabled,
	          size = _props.size,
	          sidebarSize = _props.sidebarSize;
	
	
	      var selectedTab = this.getSelectedTab();
	      var handleSelect = this.props.handleSelect || this.handleSelect;
	
	      var commonProps = {
	        isDisabled: isDisabled,
	        isVertical: isVertical,
	        handleSelect: handleSelect,
	        size: size
	      };
	
	      var tabLinks = (0, _utils.filterChildren)(children, function (child) {
	        return child.type === _TabLink2.default;
	      });
	
	      if (justified) {
	        commonProps.width = 100 / tabLinks.length;
	      }
	
	      var tabListStyles = (0, _classnames2.default)(alignClasses[align], _sidebarSize2.default[sidebarSize], (_cx = {}, _defineProperty(_cx, _general2.default.container, !isVertical), _defineProperty(_cx, _general2.default.verticalContainer, isVertical), _cx));
	
	      return _react2.default.createElement(
	        'div',
	        { className: tabListStyles },
	        tabLinks.map(function (child) {
	          var tabLinkProps = _extends({}, commonProps, {
	            isActive: child.props.to === selectedTab
	          });
	          return _react2.default.cloneElement(child, tabLinkProps);
	        })
	      );
	    }
	  }, {
	    key: 'renderActivePane',
	    value: function renderActivePane() {
	      var selectedTab = this.getSelectedTab();
	
	      return (0, _utils.findChild)(this.props.children, function (child) {
	        return child.type === _TabPane2.default && child.props.for === selectedTab;
	      });
	    }
	  }, {
	    key: 'getSelectedTab',
	    value: function getSelectedTab() {
	      return this.state.selectedTab || this.props.selectedTab || this.getFirstTabName();
	    }
	  }, {
	    key: 'getFirstTabName',
	    value: function getFirstTabName() {
	      var firstTablink = (0, _utils.findChild)(this.props.children, function (child) {
	        return child.type === _TabLink2.default;
	      });
	      return firstTablink.props.to;
	    }
	  }]);
	
	  return Tabs;
	}(_react.Component);
	
	exports.default = Tabs;
	
	
	Tabs.propTypes = {
	  align: _propTypes2.default.oneOf(Object.keys(alignClasses)),
	  children: _propTypes2.default.node,
	  isVertical: _propTypes2.default.bool,
	  isDisabled: _propTypes2.default.bool,
	  justified: _propTypes2.default.bool.isRequired,
	  size: _propTypes2.default.oneOf(Object.keys(_size2.default)),
	  sidebarSize: _propTypes2.default.oneOf(Object.keys(_sidebarSize2.default)),
	  selectedTab: _propTypes2.default.string,
	  handleSelect: _propTypes2.default.func
	};
	
	Tabs.defaultProps = {
	  align: 'left',
	  isVertical: false,
	  justified: false,
	  size: 'medium',
	  sidebarSize: 'auto'
	};
	
	/***/ }),
	
	/***/ 281:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"container":"general__container___1s9mj","withMargin":"general__withMargin___2-gzk","tab":"general__tab___3HUvi transitionDuration-l","verticalTab":"general__verticalTab___3V2Rj borderWidth-0 borderStyle-solid borderColor-snow--d","isActive":"general__isActive___35c0u"};
	
	/***/ }),
	
	/***/ 282:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"container":"general__container___lLG2r borderBottomWidth-1 borderColor-smoke borderStyle-solid borderWidth-0 inline userSelect-none","verticalContainer":"general__verticalContainer___2_UcT borderBottomWidth-0 display-flex flexDirection-column borderWidth-0 inline userSelect-none"};
	
	/***/ }),
	
	/***/ 283:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"extraSmall":"sidebarSize__extraSmall___3yQ23 width-10","small":"sidebarSize__small____CIv0 width-20","medium":"sidebarSize__medium___pCOrC width-30","large":"sidebarSize__large___1a-Ks width-40","auto":"sidebarSize__auto___RrrUa width-auto"};
	
	/***/ }),
	
	/***/ 284:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterChildren = filterChildren;
	exports.findChild = findChild;
	
	var _find = __webpack_require__(38);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _react = __webpack_require__(0);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterChildren(children, predicate) {
	  return _react.Children.toArray(children).filter(predicate);
	}
	
	function findChild(children, predicate) {
	  return (0, _find2.default)(_react.Children.toArray(children), predicate);
	}
	
	/***/ }),
	
	/***/ 29:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"light":"type__light___37Mus c-silver c-black--hover","lightBlue":"type__lightBlue___1ONWN c-silver c-marvel--hover","lightReversed":"type__lightReversed___1IV0P c-silver c-white--hover","dark":"type__dark___3peZp c-slate c-black--hover","darkToBlue":"type__darkToBlue___3basT c-slate c-marvel--hover","licoriceToBlue":"type__licoriceToBlue___-lATf c-licorice c-marvel--hover","negative":"type__negative___24MPh c-silver c-negative--hover","negativeDark":"type__negativeDark___2Ay5p c-slate c-negative--hover","blue":"type__blue___35MPc c-blue c-blue--d--hover","green":"type__green___3gt26 c-green c-green--d--hover","orange":"type__orange___3NsXR c-orange c-orange--d--hover","teal":"type__teal___2ndI7 c-teal c-teal--d--hover","purple":"type__purple___126TX c-purple c-purple--d--hover","red":"type__red___1tbbY c-red c-red--d--hover","opaque":"type__opaque___3NJPL c-white breakPointM-opacity-60 opacity-100--hover","opaqueReversed":"type__opaqueReversed___xfBCt c-white opacity-100 opacity-60--hover","snowBg":"type__snowBg___1ziSR c-slate bg-snow--hover"};
	
	/***/ }),
	
	/***/ 3:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(17);
	
	/***/ }),
	
	/***/ 38:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(1023);
	
	/***/ }),
	
	/***/ 4:
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(297);
	
	/***/ }),
	
	/***/ 76:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(3);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _noop = __webpack_require__(4);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _Link = __webpack_require__(14);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _general = __webpack_require__(281);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _size = __webpack_require__(77);
	
	var _size2 = _interopRequireDefault(_size);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var tabSizes = Object.keys(_size2.default);
	var tabStyles = _extends({}, _general2.default, _size2.default);
	var cx = _bind2.default.bind(tabStyles);
	
	var TabLink = function (_Component) {
	  _inherits(TabLink, _Component);
	
	  function TabLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TabLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabLink.__proto__ || Object.getPrototypeOf(TabLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (e) {
	      _this.props.handleSelect(_this.props.to, e);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TabLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          isActive = _props.isActive,
	          isDisabled = _props.isDisabled,
	          isVertical = _props.isVertical,
	          linkType = _props.linkType,
	          onClick = _props.onClick,
	          size = _props.size,
	          width = _props.width;
	
	
	      var containerProps = {
	        className: cx('container', {
	          withMargin: !width,
	          'pointerEvents-none': isDisabled
	        }),
	        style: { width: width + '%' },
	        onClick: this.handleSelect
	      };
	
	      var linkProps = {
	        block: !!width || isVertical,
	        isActive: isActive,
	        onClick: onClick,
	        isDisabled: isDisabled,
	        type: linkType
	      };
	
	      var tabClasses = cx(size, {
	        tab: !isVertical,
	        verticalTab: isVertical,
	        isActive: isActive && !isVertical,
	        'textAlign-center': width
	      });
	
	      return _react2.default.createElement(
	        'div',
	        containerProps,
	        _react2.default.createElement(
	          _Link2.default,
	          linkProps,
	          _react2.default.createElement(
	            'div',
	            { className: tabClasses },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return TabLink;
	}(_react.Component);
	
	exports.default = TabLink;
	
	
	TabLink.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  /** Marked as optional to supppress React warnings. See https://github.com/facebook/react/issues/4494 */
	  handleSelect: _propTypes2.default.func,
	  isActive: _propTypes2.default.bool,
	  isDisabled: _propTypes2.default.bool,
	  isVertical: _propTypes2.default.bool,
	  linkType: _propTypes2.default.string,
	  onClick: _propTypes2.default.func.isRequired,
	  size: _propTypes2.default.oneOf(tabSizes),
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  width: _propTypes2.default.number
	};
	
	TabLink.defaultProps = {
	  linkType: 'dark',
	  onClick: _noop2.default,
	  size: 'medium'
	};
	
	/***/ }),
	
	/***/ 77:
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	module.exports = {"extraSmall":"size__extraSmall___jVUAS fontSize-s paddingLeftRight-xs paddingTopBottom-xs","small":"size__small___O2ADN fontSize-s paddingLeftRight-xs paddingTopBottom-s","medium":"size__medium___2ugiQ fontSize-m paddingLeftRight-s paddingTopBottom-m"};
	
	/***/ }),
	
	/***/ 78:
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TabPane;
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(0);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TabPane(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    children
	  );
	}
	
	TabPane.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	/***/ })
	
	/******/ });
	//# sourceMappingURL=marvel-ui-tabs.js.map

/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1116);


/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = DeliverooWord;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DeliverooWord() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "115", height: "40", viewBox: "0 0 115 40" },
	    _react2.default.createElement("path", { d: "M19.51,22.45c-.3.51-1,.59-1.81.21a1.13,1.13,0,0,1-.44-1.27,1,1,0,0,1,.25-.59,1.2,1.2,0,0,1,.82-.54,1.4,1.4,0,0,1,1.32.7A1.46,1.46,0,0,1,19.51,22.45Zm-5.6-.62a1.39,1.39,0,0,1-1.48.15c-.56-.19-.79-.85-.61-1.7.17-.61.89-.71,1.28-.71a.87.87,0,0,1,.42.1c.25.11.7.37.79.75A1.34,1.34,0,0,1,13.91,21.83ZM20,2,18.61,15.66,16.19,4.14,8.57,5.77,11,17.29,0,19.64l2,9.19L21.25,33l4.42-10L27.76,2.82ZM62.74,14a1.59,1.59,0,0,0,1.11-.48,1.55,1.55,0,0,0,.44-1.12,1.55,1.55,0,0,0-1.55-1.6,1.6,1.6,0,0,0,0,3.2Zm-6,11.21h2.48V11H56.77Zm41.3.21a4.81,4.81,0,0,0,4.9-5.13,4.91,4.91,0,1,0-9.8,0,4.83,4.83,0,0,0,4.93,5.12Zm-17.73,0a6.92,6.92,0,0,0,3.88-1.13l-1-2.16a6,6,0,0,1-2.9.75,2.63,2.63,0,0,1-2.63-1.48h7a6.42,6.42,0,0,0,.11-1.16,4.86,4.86,0,1,0-9.71.05,4.81,4.81,0,0,0,5.28,5.12ZM114,20.28a4.91,4.91,0,1,0-9.8,0,4.91,4.91,0,1,0,9.8,0ZM50.66,25.39a7.22,7.22,0,0,0,3.88-1.13l-.95-2.17a5.93,5.93,0,0,1-2.91.76,2.61,2.61,0,0,1-2.62-1.49h7a5.54,5.54,0,0,0,.12-1.15,4.86,4.86,0,1,0-9.71.05,4.81,4.81,0,0,0,5.19,5.13Zm10.82-.19H64V15.33H61.48Zm6.39,0h4l2.6-9.87H71.75l-1.88,8-1.91-8H65.29ZM80,17.66a2.23,2.23,0,0,1,2.4,1.75H77.6A2.23,2.23,0,0,1,80,17.66Zm-29.7,0a2.24,2.24,0,0,1,2.39,1.75h-4.8a2.2,2.2,0,0,1,2.4-1.75Zm58.81,5.12a2.39,2.39,0,0,1-1.81-.68,2.42,2.42,0,0,1-.7-1.8,2.51,2.51,0,0,1,5,0,2.41,2.41,0,0,1-2.5,2.48Zm-72.77-2.5a2.51,2.51,0,0,1,5,0,2.51,2.51,0,0,1-5,0Zm61.74,2.5a2.39,2.39,0,0,1-1.81-.68,2.42,2.42,0,0,1-.7-1.8,2.51,2.51,0,0,1,5,0,2.39,2.39,0,0,1-.7,1.8,2.36,2.36,0,0,1-1.8.68Zm-7.27-4.9a2.3,2.3,0,0,1,1.39.44l1.18-2.68a3.3,3.3,0,0,0-1.81-.5,3,3,0,0,0-2.65,1.49l-.25-1.25H86.1l.42,1.93v7.92H89V18.94a1.89,1.89,0,0,1,1.8-1.06ZM41.65,25.2h2.6l-.44-2.05V11H41.32v5.56a3.86,3.86,0,0,0-3-1.39c-2.49,0-4.42,2.1-4.42,5.14s1.93,5.13,4.42,5.13a3.86,3.86,0,0,0,3-1.46Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Email;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEFT_MARGIN = 14; // Needed to visually align icno withing buttons
	
	function Email(_ref) {
	  var display = _ref.display,
	      withMargin = _ref.withMargin;
	
	  var style = { marginLeft: withMargin ? LEFT_MARGIN : 0 };
	  var className = 'display-' + display;
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: className,
	      height: '18',
	      style: style,
	      viewBox: '0 0 24 18',
	      width: '24'
	    },
	    _react2.default.createElement('path', { d: 'M23.993 2.787l.007.213v12c0 1.657-1.343 3-3 3h-18c-1.657 0-3-1.343-3-3v-12c0-.256.032-.504.092-.742l11.837 6.834c.18.104.378.147.571.136.193.011.391-.033.571-.136zm-.849-1.885l-10.644 6.145-11.241-6.49c.491-.35 1.092-.557 1.741-.557h18c.84 0 1.599.345 2.144.901z' })
	  );
	}
	
	Email.propTypes = {
	  display: _propTypes2.default.oneOf(['inline', 'block', 'inlineBlock']),
	  withMargin: _propTypes2.default.bool
	};
	
	Email.defaultProps = {
	  display: 'block',
	  withMargin: true
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Hudl;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Hudl() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "66", height: "40", viewBox: "0 0 66 40" },
	    _react2.default.createElement("path", { d: "M7.21,14.19a1.93,1.93,0,0,0,0-.34.06.06,0,0,1,0-.06,9.75,9.75,0,0,1,3.5-1.55.06.06,0,0,0,0-.06A9.8,9.8,0,0,0,6,10.1a9.6,9.6,0,0,0-1.34.82H4.6a3.77,3.77,0,0,0-1-.14A3.51,3.51,0,0,0,0,14.18a3.32,3.32,0,0,0,1.16,2.51,7.85,7.85,0,0,0-.09,1.19A8.6,8.6,0,0,0,3.81,24.1l.08-.05a.06.06,0,0,0,0-.08,8.58,8.58,0,0,1-.16-5.57,6.9,6.9,0,0,1,.33-.9A3.48,3.48,0,0,0,7.21,14.19Z" }),
	    _react2.default.createElement("path", { d: "M21,14.18a3.52,3.52,0,0,0-3.62-3.39,3.77,3.77,0,0,0-1,.14h-.06A9.68,9.68,0,0,0,8.17,9.29a.06.06,0,0,0-.06.06.05.05,0,0,0,0,0l0,0a9.79,9.79,0,0,1,5.2,2.69,10.21,10.21,0,0,1,.69.77.06.06,0,0,1,0,.06,3.24,3.24,0,0,0-.26,1.27A3.41,3.41,0,0,0,16,17.29a8.51,8.51,0,0,1-.37,3.58.06.06,0,0,0,0,.06v-.05a9.55,9.55,0,0,0,4.3-2.82v-.13a8.19,8.19,0,0,0-.07-1.21A3.34,3.34,0,0,0,21,14.18Z" }),
	    _react2.default.createElement("path", { d: "M14.42,23.25a4.29,4.29,0,0,1-1,.18h-.05a3.74,3.74,0,0,0-2.84-1.31,3.82,3.82,0,0,0-1.78.45l-.31.19H8.37a9.3,9.3,0,0,1-3.14-2.11H5.18a8.5,8.5,0,0,0,.47,4.91A9.32,9.32,0,0,0,7,26.21a3.25,3.25,0,0,0,.38.9,3.68,3.68,0,0,0,3.13,1.71,3.78,3.78,0,0,0,1.72-.4A3.43,3.43,0,0,0,14,26.25a9.19,9.19,0,0,0,5.5-5.85A9.68,9.68,0,0,1,14.42,23.25Z" }),
	    _react2.default.createElement("path", { d: "M43,23.55a2.9,2.9,0,0,1-.88.1c-.77,0-1.18-.29-1.18-1V15.93H36.78v6.65c0,2.94,1.77,4.11,5.32,4.11a14.65,14.65,0,0,0,5-.78v-10H43Z" }),
	    _react2.default.createElement("path", { d: "M30.81,15.77a6.19,6.19,0,0,0-2,.35v-5h-4.2v15.3h4.15V18.85a2.41,2.41,0,0,1,.88-.16c.88,0,1.26.39,1.26,1.11v6.65H35v-7C35,17.06,33.59,15.77,30.81,15.77Z" }),
	    _react2.default.createElement("path", { d: "M55.5,16a5.59,5.59,0,0,0-1.22-.16c-3.61,0-5.45,2.09-5.45,5.34,0,3.61,2.12,5.52,6,5.52a12.57,12.57,0,0,0,4.82-.77V11.15H55.51Zm0,7.7a2.42,2.42,0,0,1-.71.08c-1.16,0-1.79-.85-1.79-2.63,0-1.52.62-2.51,1.77-2.51a2.4,2.4,0,0,1,.75.12Z" }),
	    _react2.default.createElement("path", { d: "M61.85,11.15H66v15.3H61.85Z" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 1154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Yieldr;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Yieldr() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "64", height: "40", viewBox: "0 0 64 40" },
	    _react2.default.createElement("path", { d: "M13.58,9.51H11.31a.57.57,0,0,0-.44.26L7.21,15.83l-2.89-6a.55.55,0,0,0-.51-.34H1.54a.55.55,0,0,0-.54.55.41.41,0,0,0,0,.22L5.24,19c-.21,1.46-.9,6.36-1,7v.14a.55.55,0,0,0,.45.61H7a.57.57,0,0,0,.54-.46l1-6.69,5.53-9.26a.56.56,0,0,0,0-.42.54.54,0,0,0-.26-.33A.57.57,0,0,0,13.58,9.51Z" }),
	    _react2.default.createElement("path", { d: "M63.41,13.91a2.83,2.83,0,0,0-1.08-.19,3.7,3.7,0,0,0-2.81,1.76A1.62,1.62,0,0,0,59,14.33a1.66,1.66,0,0,0-1.17-.44h-1a.55.55,0,0,0-.54.44l-1.1,7.56a3.49,3.49,0,0,1-2.77,1.81c-.43,0-1-.36-.88-1.35l1.72-12.22a.55.55,0,0,0-.45-.61H50.45a.54.54,0,0,0-.58.47c0,.33-.34,2.32-.68,4.68a3.57,3.57,0,0,0-2.76-1c-3.54,0-6.74,3.08-6.74,7.89v.51a3.38,3.38,0,0,1-2.61,1.58c-.44,0-1-.36-.88-1.35L38,10.13a.55.55,0,0,0-.45-.61H35.19a.53.53,0,0,0-.53.47c-.07.52-.75,5.16-1.29,8.86-.49,1.06-2.63,5-7.19,5-1.58,0-2.39-.83-2.53-2.5h6.16a.55.55,0,0,0,.53-.45c0-.17.33-2.33.33-2.33a4,4,0,0,0-3-4.78,3.91,3.91,0,0,0-1.08-.09c-3.45,0-6.3,3.33-6.3,7.32a8.48,8.48,0,0,0,.09,1.23,3.22,3.22,0,0,1-2.48,1.46c-.44,0-1-.36-.88-1.35l1.11-7.86a.55.55,0,0,0-.45-.61H15.29a.53.53,0,0,0-.53.47c-.1.73-.74,5.08-1.18,8.1-.38,2.65,1,4.44,3.23,4.44a6.52,6.52,0,0,0,4.53-2.1,5.44,5.44,0,0,0,4.53,2.11,9.09,9.09,0,0,0,7-2.92,3.13,3.13,0,0,0,3.25,2.94,6.48,6.48,0,0,0,4.45-2,4.14,4.14,0,0,0,3.82,2,5.49,5.49,0,0,0,4-1.81,3.06,3.06,0,0,0,2.94,1.81,6,6,0,0,0,3.24-1v.28a.53.53,0,0,0,.14.4.54.54,0,0,0,.39.19h2.3a.54.54,0,0,0,.53-.46l.89-6.2c.28-1.94,1.43-3,3-3a3.37,3.37,0,0,1,1,.15.57.57,0,0,0,.66-.44l.33-2.27a.54.54,0,0,0-.4-.65ZM26.2,16.61c1.06,0,1.25,1,1.1,2H24C24.41,17.43,25.19,16.61,26.2,16.61Zm18.86,7.11c-1.54,0-2-1.29-2-2.62,0-2.06,1.6-4.28,3.43-4.3,1,0,1.91.55,1.92,2.26.06,2.24-1.33,4.66-3.36,4.66Z" }),
	    _react2.default.createElement("circle", { cx: "17.05", cy: "10.85", r: "1.85" })
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = CaseStudies;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _logoRow = __webpack_require__(53);
	
	var _logoRow2 = _interopRequireDefault(_logoRow);
	
	var _MediaFeature = __webpack_require__(68);
	
	var _MediaFeature2 = _interopRequireDefault(_MediaFeature);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _assets = __webpack_require__(951);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _caseStudyLogos = __webpack_require__(1236);
	
	var _caseStudyLogos2 = _interopRequireDefault(_caseStudyLogos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CaseStudies() {
	  var Mobile = function Mobile(props) {
	    return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { maxWidth: 770 }));
	  };
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { sizeM: 'xl', position: 'topBottom', type: 'margin' },
	    _react2.default.createElement(
	      _MediaFeature2.default,
	      {
	        borderRadius: 'none',
	        src: _assets2.default.caseStudies.src,
	        alt: 'The world\'s most innovative companies use Marvel everyday to scale design',
	        hasShadow: false,
	        backgroundColor: 'white'
	      },
	      _react2.default.createElement(
	        _HeadingBlock2.default,
	        {
	          alignContent: 'center',
	          alignM: 'left',
	          headingSize: 'xxl',
	          paragraphMaxWidth: 400,
	          headingMaxWidth: 346,
	          title: 'The world\'s most innovative companies use Marvel everyday to scale design',
	          copy: _react2.default.createElement(
	            'span',
	            null,
	            'The digital products, from around the world, that you know and love have been built with Marvel.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Our customers range from Fortune 100 companies, to startups and schools - all using our online design platform to ideate fast, collaborate and optimise prototypes before development.'
	          )
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/customer-stories/' },
	            _react2.default.createElement(
	              _button2.default,
	              { shape: 'rounded', kind: 'ghost', size: 'large' },
	              'Read Customer Stories'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 400 },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', position: 'topBottom', type: 'margin' },
	            _react2.default.createElement(
	              Mobile,
	              null,
	              _react2.default.createElement(_logoRow2.default, { logos: _caseStudyLogos2.default, align: 'left' })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ImageRightSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageRightSection(_ref) {
	  var artwork = _ref.artwork,
	      buttonText = _ref.buttonText,
	      copy = _ref.copy,
	      link = _ref.link,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    _grid2.default,
	    { columns: 12, alignItems: 'center' },
	    _react2.default.createElement(
	      _grid.GridItem,
	      { columnSpan: 12, columnSpanM: 6 },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: 770 },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', type: 'margin', position: 'bottom' },
	          artwork
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', type: 'margin', position: 'bottom' },
	        _react2.default.createElement(_HeadingBlock2.default, {
	          maxWidth: 420,
	          justifyContent: 'center',
	          justifyM: 'start',
	          alignContent: 'center',
	          alignM: 'left',
	          title: title,
	          copy: copy
	        })
	      ),
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center', typeM: 'left' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: link },
	          _react2.default.createElement(
	            _button2.default,
	            { shape: 'rounded', kind: 'ghost', size: 'large' },
	            buttonText
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _grid.GridItem,
	      { columnSpan: 12, columnSpanM: 6 },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: 770 },
	        artwork
	      )
	    )
	  );
	}
	
	ImageRightSection.propTypes = {
	  artwork: _propTypes2.default.object,
	  buttonText: _propTypes2.default.string,
	  copy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  link: _propTypes2.default.string,
	  title: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = MarvelEnterprise;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _ImageRightBlock = __webpack_require__(150);
	
	var _ImageRightBlock2 = _interopRequireDefault(_ImageRightBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MarvelEnterprise(_ref) {
	  var buttonText = _ref.buttonText,
	      copy = _ref.copy,
	      image = _ref.image,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'm', sizeM: 'xl', type: 'padding', position: 'topBottom' },
	      _react2.default.createElement(_ImageRightBlock2.default, {
	        title: title,
	        artwork: image,
	        buttonText: buttonText,
	        copy: copy,
	        link: '/enterprise'
	      })
	    )
	  );
	}
	
	MarvelEnterprise.propTypes = {
	  image: _propTypes2.default.object,
	  buttonText: _propTypes2.default.string,
	  copy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  title: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _tabs = __webpack_require__(1118);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ArrowRight = __webpack_require__(93);
	
	var _ArrowRight2 = _interopRequireDefault(_ArrowRight);
	
	var _tabs2 = __webpack_require__(952);
	
	var _tabs3 = _interopRequireDefault(_tabs2);
	
	var _powerfulDesignModule = __webpack_require__(1490);
	
	var _powerfulDesignModule2 = _interopRequireDefault(_powerfulDesignModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = _bind2.default.bind(_extends({}, _powerfulDesignModule2.default));
	
	var PowerfulDesignDesktop = function (_Component) {
	  _inherits(PowerfulDesignDesktop, _Component);
	
	  function PowerfulDesignDesktop() {
	    _classCallCheck(this, PowerfulDesignDesktop);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = {
	      selectedTab: 'tab0'
	    };
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PowerfulDesignDesktop.prototype.handleSelect = function handleSelect(selectedTab) {
	    this.setState({ selectedTab: selectedTab });
	  };
	
	  PowerfulDesignDesktop.prototype.render = function render() {
	    var selectedTab = this.state.selectedTab;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: _powerfulDesignModule2.default.container },
	      _react2.default.createElement(
	        _tabs.Tabs,
	        {
	          handleSelect: this.handleSelect,
	          selectedTab: selectedTab,
	          isVertical: true,
	          sidebarSize: 'medium'
	        },
	        _tabs3.default.map(function (item, index) {
	          var tab = 'tab' + index;
	          var isSelected = selectedTab === tab;
	          var headingColor = isSelected ? 'blue' : 'black';
	          var arrowClassName = cx('arrow', {
	            arrowActive: isSelected
	          });
	
	          return _react2.default.createElement(
	            _tabs.TabLink,
	            { key: item.id, to: tab },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'xxs', position: 'topBottom', type: 'padding' },
	              _react2.default.createElement(
	                _spacing2.default,
	                { size: 'xs', position: 'bottom', type: 'margin' },
	                _react2.default.createElement(
	                  'div',
	                  { className: cx('titleContainer') },
	                  _react2.default.createElement(
	                    'div',
	                    { className: arrowClassName },
	                    _react2.default.createElement(_ArrowRight2.default, null)
	                  ),
	                  _react2.default.createElement(
	                    _heading2.default,
	                    { tag: 'h3', size: 'l', weight: 'semibold' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'c-' + headingColor },
	                      item.title
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _maxWidth2.default,
	                { value: 210 },
	                _react2.default.createElement(
	                  _paragraph2.default,
	                  { size: 'm', color: 'slate' },
	                  item.subtitle
	                )
	              )
	            )
	          );
	        }),
	        _tabs3.default.map(function (item, index) {
	          return _react2.default.createElement(
	            _tabs.TabPane,
	            { key: item.id, 'for': 'tab' + index },
	            _react2.default.createElement(
	              'div',
	              { className: _powerfulDesignModule2.default.imageContainer },
	              _react2.default.createElement(_Image2.default, _extends({}, item, { hasShadow: false }))
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return PowerfulDesignDesktop;
	}(_react.Component);
	
	exports.default = PowerfulDesignDesktop;
	module.exports = exports['default'];

/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = PowerfulDesignMobile;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _tabs = __webpack_require__(952);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PowerfulDesignMobile() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _tabs2.default.map(function (tab) {
	      return _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', position: 'topBottom', type: 'margin', key: tab.id },
	        _react2.default.createElement(
	          _align2.default,
	          { type: 'center' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h3', size: 'xl', weight: 'semibold' },
	            tab.title
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', position: 'topBottom', type: 'margin' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              null,
	              tab.subtitle
	            )
	          ),
	          _react2.default.createElement(_Image2.default, _extends({}, tab, {
	            src: tab.srcMobile,
	            alt: tab.title,
	            hasShadow: false
	          }))
	        )
	      );
	    })
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = PowerfulDesign;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _SmartLink = __webpack_require__(36);
	
	var _SmartLink2 = _interopRequireDefault(_SmartLink);
	
	var _PowerfulDesignDesktop = __webpack_require__(1205);
	
	var _PowerfulDesignDesktop2 = _interopRequireDefault(_PowerfulDesignDesktop);
	
	var _PowerfulDesignMobile = __webpack_require__(1206);
	
	var _PowerfulDesignMobile2 = _interopRequireDefault(_PowerfulDesignMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PowerfulDesign() {
	  var Desktop = function Desktop(props) {
	    return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { minWidth: 770 }));
	  };
	  var Mobile = function Mobile(props) {
	    return _react2.default.createElement(_reactResponsive2.default, _extends({}, props, { maxWidth: 770 }));
	  };
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'xl', position: 'topBottom' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      null,
	      _react2.default.createElement(
	        _HeadingBlock2.default,
	        {
	          size: 'm',
	          alignContent: 'center',
	          alignM: 'center',
	          spacing: 'm',
	          title: 'Your design process, in one place',
	          paragraphMaxWidth: 540,
	          copy: _react2.default.createElement(
	            'span',
	            null,
	            'Wireframe, design and prototype fast with our intuitive design and prototyping tools. Instantly generate design specs and connect integrations that power up your workflow. From low to high-fidelity, Marvel supports you every step of the way.'
	          )
	        },
	        _react2.default.createElement(
	          _button2.default,
	          { shape: 'rounded', size: 'large' },
	          _react2.default.createElement(
	            _SmartLink2.default,
	            { url: '/why-marvel' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-white' },
	              'Find out more'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', position: 'topBottom', type: 'margin' },
	        _react2.default.createElement(
	          Desktop,
	          null,
	          _react2.default.createElement(_PowerfulDesignDesktop2.default, null)
	        ),
	        _react2.default.createElement(
	          Mobile,
	          null,
	          _react2.default.createElement(_PowerfulDesignMobile2.default, null)
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1490:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-modules-PowerfulDesign-style----powerful-design-module---container---p-X8g","imageContainer":"src-components-modules-PowerfulDesign-style----powerful-design-module---imageContainer---2g6aA height-100 position-relative textAlign-right width-100","titleContainer":"src-components-modules-PowerfulDesign-style----powerful-design-module---titleContainer---C9Q2m display-flex position-relative","arrow":"src-components-modules-PowerfulDesign-style----powerful-design-module---arrow---1bSau position-absolute pinTL fill-blue transitionDuration-l transitionTimingFunction-easeInOut opacity-0","arrowActive":"src-components-modules-PowerfulDesign-style----powerful-design-module---arrowActive---Uxl2_ opacity-100"};

/***/ }),

/***/ 1217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _urls = __webpack_require__(84);
	
	var _welcomeModule = __webpack_require__(1494);
	
	var _welcomeModule2 = _interopRequireDefault(_welcomeModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WelcomeMessage = function (_React$Component) {
	  _inherits(WelcomeMessage, _React$Component);
	
	  function WelcomeMessage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WelcomeMessage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isLoading: false
	    }, _this.toggleLoadingState = function () {
	      _this.setState({ isLoading: !_this.state.isLoading });
	    }, _this.onClick = function () {
	      _this.toggleLoadingState();
	      window.location.href = _urls.MARVELAPP_PROJECTS;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  WelcomeMessage.prototype.render = function render() {
	    var style = {
	      paddingRight: this.state.isLoading ? 170 : 155
	    };
	    return _react2.default.createElement(
	      'div',
	      { className: _welcomeModule2.default.pill, style: style },
	      _react2.default.createElement(
	        'div',
	        { className: _welcomeModule2.default.truncate },
	        'Welcome back',
	        this.props.username && ', ' + this.props.username
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _welcomeModule2.default.absolute },
	        _react2.default.createElement(
	          _button2.default,
	          {
	            background: 'blue',
	            color: 'white',
	            isLoading: this.state.isLoading,
	            onClick: this.onClick,
	            shape: 'rounded'
	          },
	          'Go to dashboard'
	        )
	      )
	    );
	  };
	
	  return WelcomeMessage;
	}(_react2.default.Component);
	
	exports.default = WelcomeMessage;
	
	
	WelcomeMessage.propTypes = {
	  username: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1494:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pill":"src-components-modules-WelcomeMessage-style----welcome-module---pill---lRTpa display-inlineFlex borderColor-smoke borderStyle-solid borderWidth-1 marginTopBottom-l paddingLeft-m position-relative transitionDuration-m","truncate":"src-components-modules-WelcomeMessage-style----welcome-module---truncate---WfUzA fontSize-m truncateText","bold":"src-components-modules-WelcomeMessage-style----welcome-module---bold---1ywO- fontWeight-5","absolute":"src-components-modules-WelcomeMessage-style----welcome-module---absolute---2uzA9 position-absolute"};

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _heroNew2x = __webpack_require__(2636);
	
	var _heroNew2x2 = _interopRequireDefault(_heroNew2x);
	
	var _caseStudies2x = __webpack_require__(2645);
	
	var _caseStudies2x2 = _interopRequireDefault(_caseStudies2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  hero: {
	    alt: '',
	    src: _heroNew2x2.default,
	    maxWidth: 762
	  },
	  caseStudies: {
	    alt: '',
	    src: _caseStudies2x2.default,
	    maxWidth: 1500
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 1236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Buzzfeed = __webpack_require__(182);
	
	var _Buzzfeed2 = _interopRequireDefault(_Buzzfeed);
	
	var _Cabify = __webpack_require__(184);
	
	var _Cabify2 = _interopRequireDefault(_Cabify);
	
	var _DeliverooWord = __webpack_require__(1140);
	
	var _DeliverooWord2 = _interopRequireDefault(_DeliverooWord);
	
	var _Monzo = __webpack_require__(94);
	
	var _Monzo2 = _interopRequireDefault(_Monzo);
	
	var _Yieldr = __webpack_require__(1154);
	
	var _Yieldr2 = _interopRequireDefault(_Yieldr);
	
	var _Hudl = __webpack_require__(1146);
	
	var _Hudl2 = _interopRequireDefault(_Hudl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var caseStudyLogos = [{
	  id: 2,
	  logo: _Cabify2.default
	}, {
	  id: 0,
	  logo: _Buzzfeed2.default
	}, {
	  id: 3,
	  logo: _Yieldr2.default
	}, {
	  id: 1,
	  logo: _Monzo2.default
	}, {
	  id: 4,
	  logo: _Hudl2.default
	}, {
	  id: 5,
	  logo: _DeliverooWord2.default
	}];
	
	exports.default = caseStudyLogos;
	module.exports = exports['default'];

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BlaBlaCar = __webpack_require__(145);
	
	var _BlaBlaCar2 = _interopRequireDefault(_BlaBlaCar);
	
	var _Buzzfeed = __webpack_require__(182);
	
	var _Buzzfeed2 = _interopRequireDefault(_Buzzfeed);
	
	var _Cabify = __webpack_require__(184);
	
	var _Cabify2 = _interopRequireDefault(_Cabify);
	
	var _Mode = __webpack_require__(190);
	
	var _Mode2 = _interopRequireDefault(_Mode);
	
	var _Typeform = __webpack_require__(462);
	
	var _Typeform2 = _interopRequireDefault(_Typeform);
	
	var _Monzo = __webpack_require__(94);
	
	var _Monzo2 = _interopRequireDefault(_Monzo);
	
	var _Trainline = __webpack_require__(461);
	
	var _Trainline2 = _interopRequireDefault(_Trainline);
	
	var _Stripe = __webpack_require__(117);
	
	var _Stripe2 = _interopRequireDefault(_Stripe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homepageLogos = [{
	  id: 0,
	  logo: _Buzzfeed2.default
	}, {
	  id: 1,
	  logo: _Monzo2.default
	}, {
	  id: 2,
	  logo: _Cabify2.default
	}, {
	  id: 3,
	  logo: _Typeform2.default
	}, {
	  id: 4,
	  logo: _Stripe2.default
	}, {
	  id: 5,
	  logo: _Trainline2.default
	}, {
	  id: 6,
	  logo: _Mode2.default
	}, {
	  id: 7,
	  logo: _BlaBlaCar2.default
	}];
	
	exports.default = homepageLogos;
	module.exports = exports['default'];

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _designing2x = __webpack_require__(2638);
	
	var _designing2x2 = _interopRequireDefault(_designing2x);
	
	var _prototyping2x = __webpack_require__(2640);
	
	var _prototyping2x2 = _interopRequireDefault(_prototyping2x);
	
	var _handoff2x = __webpack_require__(2642);
	
	var _handoff2x2 = _interopRequireDefault(_handoff2x);
	
	var _collaboration2x = __webpack_require__(2644);
	
	var _collaboration2x2 = _interopRequireDefault(_collaboration2x);
	
	var _usertesting2x = __webpack_require__(2647);
	
	var _usertesting2x2 = _interopRequireDefault(_usertesting2x);
	
	var _designingSmall = __webpack_require__(2637);
	
	var _designingSmall2 = _interopRequireDefault(_designingSmall);
	
	var _prototypingSmall = __webpack_require__(2639);
	
	var _prototypingSmall2 = _interopRequireDefault(_prototypingSmall);
	
	var _handoffSmall = __webpack_require__(2641);
	
	var _handoffSmall2 = _interopRequireDefault(_handoffSmall);
	
	var _collaborationSmall = __webpack_require__(2643);
	
	var _collaborationSmall2 = _interopRequireDefault(_collaborationSmall);
	
	var _usertestingSmall = __webpack_require__(2646);
	
	var _usertestingSmall2 = _interopRequireDefault(_usertestingSmall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homePageTabs = [{
	  id: 0,
	  title: 'Design and Wireframe',
	  subtitle: 'Create beautiful interfaces and wireframes in minutes',
	  src: _designing2x2.default,
	  srcMobile: _designingSmall2.default,
	  maxWidth: 950
	}, {
	  id: 1,
	  title: 'Prototype',
	  subtitle: 'Make designs interactive. No code required',
	  src: _prototyping2x2.default,
	  srcMobile: _prototypingSmall2.default,
	  maxWidth: 950
	}, {
	  id: 2,
	  title: 'Handoff',
	  subtitle: 'Design to development, automated',
	  src: _handoff2x2.default,
	  srcMobile: _handoffSmall2.default,
	  maxWidth: 950
	}, {
	  id: 3,
	  title: 'User Testing',
	  subtitle: 'See how users interact with your designs and prototypes',
	  src: _usertesting2x2.default,
	  srcMobile: _usertestingSmall2.default,
	  maxWidth: 950
	}, {
	  id: 4,
	  title: 'Collaboration',
	  subtitle: 'Centralise feedback and ideas',
	  src: _collaboration2x2.default,
	  srcMobile: _collaborationSmall2.default,
	  maxWidth: 950
	}];
	
	exports.default = homePageTabs;
	module.exports = exports['default'];

/***/ }),

/***/ 2636:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/00-hero-new@2x-f6a65160e5b1177c269e9e1b7e0cf7d2.jpg";

/***/ }),

/***/ 2637:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/01-designing-small-6904228e318e7e828fbe26f32387f2d1.jpg";

/***/ }),

/***/ 2638:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/01-designing@2x-ee1cb59c64e0a1c8109fec99cf690b7e.jpg";

/***/ }),

/***/ 2639:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/02-prototyping-small-366cd80086b4c32ba609be16c8dc71f0.jpg";

/***/ }),

/***/ 2640:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/02-prototyping@2x-03d27b041008f953c77e984ee55816e6.jpg";

/***/ }),

/***/ 2641:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/03-handoff-small-7384948d6969354a0a37ed54745716b1.jpg";

/***/ }),

/***/ 2642:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/03-handoff@2x-c9fee0a716cabe557c96bb96ae73eeb5.jpg";

/***/ }),

/***/ 2643:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/04-collaboration-small-c6a02116e187fd7a1a70292e8d25dd14.jpg";

/***/ }),

/***/ 2644:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/04-collaboration@2x-900778ae1ac106accc97a2a419132a2a.jpg";

/***/ }),

/***/ 2645:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/05-caseStudies@2x-03a05845e8b2525ba4ce74ddc87e9590.png";

/***/ }),

/***/ 2646:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/06-usertesting-small-7304fa0a3b8bc06c001c10fed830b126.jpg";

/***/ }),

/***/ 2647:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/06-usertesting@2x-98e2a9298ef2c5193efdb5c9276609a8.jpg";

/***/ }),

/***/ 2714:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/marvel-three-dashboard@2x-8f0fd15a2f41bceb8ce6bd49e3b96bdb.jpg";

/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HOME_PAGE_QUERY = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(38);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _logoRow = __webpack_require__(53);
	
	var _logoRow2 = _interopRequireDefault(_logoRow);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _CaseStudies = __webpack_require__(1156);
	
	var _CaseStudies2 = _interopRequireDefault(_CaseStudies);
	
	var _WelcomeMessage = __webpack_require__(1217);
	
	var _WelcomeMessage2 = _interopRequireDefault(_WelcomeMessage);
	
	var _PowerfulDesign = __webpack_require__(1207);
	
	var _PowerfulDesign2 = _interopRequireDefault(_PowerfulDesign);
	
	var _IntegrationsCta = __webpack_require__(118);
	
	var _IntegrationsCta2 = _interopRequireDefault(_IntegrationsCta);
	
	var _selectors = __webpack_require__(69);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _forms = __webpack_require__(49);
	
	var _assets = __webpack_require__(951);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _Email = __webpack_require__(1143);
	
	var _Email2 = _interopRequireDefault(_Email);
	
	var _MarvelEnterprise = __webpack_require__(594);
	
	var _MarvelEnterprise2 = _interopRequireDefault(_MarvelEnterprise);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _logos = __webpack_require__(228);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _marvelThreeDashboard2x = __webpack_require__(2714);
	
	var _marvelThreeDashboard2x2 = _interopRequireDefault(_marvelThreeDashboard2x);
	
	var _deviceDetection = __webpack_require__(954);
	
	var _GoogleButton = __webpack_require__(946);
	
	var _GoogleButton2 = _interopRequireDefault(_GoogleButton);
	
	var _generalModule = __webpack_require__(761);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Temporary workaround to disable Google Sign in on iOS/iPadOS and server-side
	// when generating the HTML template
	var showGoogleSign = !(0, _deviceDetection.isIOSOrIPadOS)() && !!(true);
	
	function Homepage(_ref) {
	  var isLoggedIn = _ref.isLoggedIn,
	      username = _ref.username,
	      data = _ref.data;
	
	  if (typeof window !== 'undefined' && window.ga) {
	    window.ga('send', 'pageview', isLoggedIn ? '/return-to-dashboard/' : '/');
	  }
	
	  var schema = JSON.stringify({
	    '@context': 'https://schema.org',
	    '@type': 'Organization',
	    name: 'Marvel',
	    alternateName: 'Marvel App',
	    description: 'Marvel is an all-in-one design platform, which includes rapid prototyping, user testing and designer to developer code handoff, created for modern design teams.',
	    url: 'https://marvelapp.com/',
	    email: 'sales@marvelapp.com',
	    logo: 'https://marvelapp.com/wp-content/uploads/2018/06/Logo-Light.png',
	    sameAs: ['https://www.facebook.com/marvelapp', 'https://twitter.com/marvelapp', 'https://www.instagram.com/marvelapp/', 'https://www.youtube.com/channel/UCPyHK9eJgCs-fkq4yxc1EXw?pbjreload=102', 'https://www.linkedin.com/company/marvel-app/', 'https://github.com/marvelapp', 'https://marvelapp.com/']
	  });
	
	  var pageProps = {
	    title: _metadata2.default.homepage.title,
	    meta: [{
	      name: 'description',
	      content: _metadata2.default.homepage.description
	    }, {
	      name: 'keywords',
	      content: _metadata2.default.homepage.keywords
	    }],
	    header: true,
	    footer: true,
	    banner: true,
	    schema: schema
	  };
	
	  var redirectTo = (0, _forms.getNextSignupRedirect)();
	  return _react2.default.createElement(
	    _Page2.default,
	    pageProps,
	    _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.page },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'l', sizeM: 'xl', position: 'top', type: 'padding' },
	        _react2.default.createElement(
	          _pageWrap2.default,
	          { size: 'l' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { type: 'padding', size: 'xl', position: 'topBottom' },
	            _react2.default.createElement(
	              _grid2.default,
	              { columns: 12, alignItems: 'center' },
	              _react2.default.createElement(
	                _grid.GridItem,
	                { columnSpan: 12, columnSpanM: 5 },
	                _react2.default.createElement(
	                  _align2.default,
	                  { type: 'center', typeM: 'left' },
	                  _react2.default.createElement(
	                    _maxWidth2.default,
	                    { value: 480, display: 'inlineBlock' },
	                    _react2.default.createElement(
	                      _heading2.default,
	                      { tag: 'h1', size: 'xxxxl', weight: 'semibold' },
	                      'Rapid prototyping, testing and handoff for modern design teams'
	                    ),
	                    _react2.default.createElement(
	                      _spacing2.default,
	                      { type: 'margin', size: 'xs', position: 'top' },
	                      _react2.default.createElement(
	                        _paragraph2.default,
	                        { size: 'l' },
	                        'Marvel has everything you need to bring ideas to life and transform how you create digital products with your team. Placing the power of design in everyone\u2019s hands.'
	                      )
	                    )
	                  ),
	                  isLoggedIn ? _react2.default.createElement(_WelcomeMessage2.default, { username: username }) : _react2.default.createElement(
	                    _spacing2.default,
	                    { type: 'padding', size: 'l', position: 'topBottom' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'display-flex flexWrap-wrap justifyContent-center breakPointM-justifyContent-flexStart' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'breakPointS-marginRight-s marginBottom-s' },
	                        _react2.default.createElement(
	                          _link2.default,
	                          { url: '/signup', openInNewTab: false },
	                          _react2.default.createElement(
	                            _button2.default,
	                            {
	                              background: 'blue',
	                              color: 'white',
	                              size: 'large',
	                              shape: 'rounded',
	                              minWidth: 240,
	                              iconColor: 'white',
	                              icon: _react2.default.createElement(_Email2.default, null)
	                            },
	                            'Sign up free with email'
	                          )
	                        )
	                      ),
	                      showGoogleSign && _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          _GoogleButton2.default,
	                          {
	                            shape: 'rounded',
	                            redirectTo: redirectTo,
	                            siteMaintenance: data.site.siteMetadata.siteMaintenance
	                          },
	                          'Sign up free with Google'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _grid.GridItem,
	                { columnSpan: 12, columnSpanM: 7 },
	                _react2.default.createElement(_Image2.default, {
	                  alt: 'The all-in-one design platform powering creatives',
	                  maxWidth: _assets2.default.hero.maxWidth,
	                  src: _assets2.default.hero.src,
	                  hasShadow: false,
	                  useImageTag: true
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', position: 'topBottom', type: 'margin' },
	        _react2.default.createElement(_logoRow2.default, { logos: _logos2.default })
	      ),
	      _react2.default.createElement(_PowerfulDesign2.default, null),
	      _react2.default.createElement(_CaseStudies2.default, null),
	      _react2.default.createElement(_MarvelEnterprise2.default, {
	        buttonText: 'Learn more',
	        copy: 'Built to help large teams create amazing products at scale. Marvel Enterprise 3 is built on blazing fast technology with features that focus on helping large teams make design more productive.',
	        image: _react2.default.createElement(_Image2.default, {
	          alt: 'Marvel Enterprise Dashboard',
	          src: _marvelThreeDashboard2x2.default,
	          maxWidth: 700,
	          hasShadow: false
	        }),
	        title: 'Scale Design with Marvel Enterprise 3'
	      }),
	      _react2.default.createElement(_IntegrationsCta2.default, null)
	    )
	  );
	}
	
	var HOME_PAGE_QUERY = exports.HOME_PAGE_QUERY = '** extracted graphql fragment **';
	
	Homepage.propTypes = {
	  isLoggedIn: _propTypes2.default.bool.isRequired,
	  username: _propTypes2.default.string,
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        siteMaintenance: _propTypes2.default.bool.isRequired
	      }).isRequired
	    }).isRequired
	  }).isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    isLoggedIn: (0, _selectors.isUserLoggedIn)(state),
	    username: (0, _selectors.getUsername)(state)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Homepage);

/***/ }),

/***/ 761:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"page":"src-pages-style----general-module---page---1osdA overflow-hidden"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-791d7dec15f3563e6290.js